import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { createNewUser } from '../redux/actions/auth.action';
import PlatformButton from '../components/platform/PlatformButton';
import PlatformField from '../components/platform/PlatformField';
import '../styles/platform-dashboard.css';

export default function CreateUsersPage() {
  const { company } = useSelector((state) => state.auth);
  const [values, setValues] = useState({
    email: '',
    confirmEmail: '',
  });
  const [error, setError] = useState('');
  const [message, setMessage] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const dispatch = useDispatch();

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setValues((current) => ({
      ...current,
      [name]: value,
    }));
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    setError('');
    setMessage('');

    if (!values.email || !values.confirmEmail) {
      setError('Please enter and confirm the email address.');
      return;
    }

    if (values.email.trim().toLowerCase() !== values.confirmEmail.trim().toLowerCase()) {
      setError('Email addresses do not match.');
      return;
    }

    dispatch(createNewUser(
      values.email.trim(),
      company?.companyID,
      setIsLoading,
      setMessage
    ));
  };

  return (
    <div className="nurturer-platform">
      <div className="settings-view platform-fade">
        {error && <div className="platform-alert platform-alert--error">{error}</div>}
        {message && (
          <div className={`platform-alert ${message.includes('successfully') ? 'platform-alert--success' : 'platform-alert--error'}`}>
            {message}
          </div>
        )}

        <form onSubmit={handleSubmit} className="platform-card settings-card">
          <div className="settings-grid">
            <PlatformField label="Email address">
              <input
                className="platform-input"
                type="email"
                name="email"
                value={values.email}
                onChange={handleInputChange}
                placeholder="user@company.com"
              />
            </PlatformField>

            <PlatformField label="Confirm email address">
              <input
                className="platform-input"
                type="email"
                name="confirmEmail"
                value={values.confirmEmail}
                onChange={handleInputChange}
                placeholder="user@company.com"
              />
            </PlatformField>
          </div>

          <div className="platform-row" style={{ justifyContent: 'flex-end', marginTop: 8 }}>
            <PlatformButton variant="primary" size="md" type="submit" disabled={isLoading}>
              {isLoading ? 'Adding…' : 'Add user'}
            </PlatformButton>
          </div>
        </form>
      </div>
    </div>
  );
}
